export default __webpack_public_path__ + "static/media/background-light-4.47c2c3ff.jpg";